// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────
   SimpleCRM Calendar — professional theme overrides for FullCalendar
   Matches CRM neutral grays + brand red accents. Polished & dense.
   ──────────────────────────────────────────────────────────────────────── */

.crm-calendar-wrapper {
    --crm-bg: #FFFFFF;
    --crm-bg-soft: #F9FAFB;
    --crm-bg-hover: #F3F4F6;
    --crm-border: #E5E7EB;
    --crm-border-soft: #F1F2F4;
    --crm-text: #111827;
    --crm-text-soft: #6B7280;
    --crm-text-muted: #9CA3AF;
    --crm-accent: #DB0011;
    --crm-accent-soft: #FEF2F2;
    --crm-primary: #2563EB;
    --crm-primary-soft: #EFF6FF;
    --crm-success: #10B981;
    --crm-warning: #F59E0B;
    --crm-danger: #EF4444;
}

/* Override FullCalendar CSS variables */
.crm-calendar-wrapper .fc {
    --fc-border-color: var(--crm-border);
    --fc-page-bg-color: var(--crm-bg);
    --fc-neutral-bg-color: var(--crm-bg-soft);
    --fc-list-event-hover-bg-color: var(--crm-bg-soft);
    --fc-today-bg-color: rgba(59, 130, 246, 0.05);
    --fc-now-indicator-color: var(--crm-accent);
    --fc-event-text-color: #FFFFFF;
    --fc-button-bg-color: #FFFFFF;
    --fc-button-text-color: var(--crm-text);
    --fc-button-border-color: var(--crm-border);
    --fc-button-hover-bg-color: var(--crm-bg-soft);
    --fc-button-hover-border-color: #D1D5DB;
    --fc-button-active-bg-color: var(--crm-text);
    --fc-button-active-border-color: var(--crm-text);

    font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 13px;
    color: var(--crm-text);
}

/* ── Header toolbar ─────────────────────────────────────────────────── */
.crm-calendar-wrapper .fc .fc-toolbar.fc-header-toolbar {
    margin-bottom: 0.75rem;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.crm-calendar-wrapper .fc .fc-toolbar-title {
    font-size: 1.05rem !important;
    font-weight: 600;
    color: var(--crm-text);
    letter-spacing: -0.01em;
}

.crm-calendar-wrapper .fc .fc-button {
    border-radius: 6px !important;
    padding: 0.375rem 0.75rem !important;
    font-size: 0.75rem !important;
    font-weight: 500 !important;
    text-transform: capitalize !important;
    box-shadow: none !important;
    transition: background-color 0.12s, color 0.12s, border-color 0.12s !important;
    line-height: 1.2 !important;
}

.crm-calendar-wrapper .fc .fc-button:focus {
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.18) !important;
}

.crm-calendar-wrapper .fc .fc-button-primary:not(.fc-button-active) {
    background-color: #FFFFFF !important;
    color: var(--crm-text) !important;
    border-color: var(--crm-border) !important;
}

.crm-calendar-wrapper .fc .fc-button-primary:not(.fc-button-active):hover {
    background-color: var(--crm-bg-soft) !important;
}

.crm-calendar-wrapper .fc .fc-button-primary.fc-button-active {
    background-color: var(--crm-text) !important;
    color: #FFFFFF !important;
    border-color: var(--crm-text) !important;
}

.crm-calendar-wrapper .fc .fc-button-group > .fc-button {
    border-radius: 0 !important;
}

.crm-calendar-wrapper .fc .fc-button-group > .fc-button:first-child {
    border-top-left-radius: 6px !important;
    border-bottom-left-radius: 6px !important;
}

.crm-calendar-wrapper .fc .fc-button-group > .fc-button:last-child {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
}

.crm-calendar-wrapper .fc .fc-today-button {
    background-color: var(--crm-primary-soft) !important;
    color: var(--crm-primary) !important;
    border-color: #BFDBFE !important;
}

.crm-calendar-wrapper .fc .fc-today-button:hover {
    background-color: #DBEAFE !important;
}

.crm-calendar-wrapper .fc .fc-today-button:disabled {
    opacity: 0.5 !important;
}

/* ── Grid & cells ───────────────────────────────────────────────────── */
.crm-calendar-wrapper .fc-scrollgrid {
    border-radius: 8px;
    overflow: hidden;
    border-color: var(--crm-border) !important;
}

.crm-calendar-wrapper .fc-scrollgrid-section-header > * {
    background-color: var(--crm-bg-soft);
}

.crm-calendar-wrapper .fc .fc-col-header-cell {
    background-color: var(--crm-bg-soft);
    padding: 0.625rem 0.25rem;
    border-color: var(--crm-border) !important;
}

.crm-calendar-wrapper .fc .fc-col-header-cell-cushion {
    color: var(--crm-text-soft);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 0 !important;
    text-decoration: none !important;
}

.crm-calendar-wrapper .fc .fc-daygrid-day-frame,
.crm-calendar-wrapper .fc .fc-timegrid-col-frame {
    background-color: var(--crm-bg);
}

.crm-calendar-wrapper .fc .fc-day-other .fc-daygrid-day-top {
    opacity: 0.35;
}

.crm-calendar-wrapper .fc .fc-daygrid-day-number {
    padding: 0.4rem 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--crm-text-soft);
    text-decoration: none !important;
}

.crm-calendar-wrapper .fc .fc-day-today .fc-daygrid-day-number {
    background-color: var(--crm-accent);
    color: #FFFFFF !important;
    border-radius: 999px;
    width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0.25rem;
    font-weight: 600;
}

/* Today column highlight (week / day views) */
.crm-calendar-wrapper .fc .fc-day-today {
    background-color: rgba(59, 130, 246, 0.04) !important;
}

/* ── Time slot grid ─────────────────────────────────────────────────── */
.crm-calendar-wrapper .fc .fc-timegrid-slot {
    height: 2.5rem;
    border-color: var(--crm-border-soft) !important;
}

.crm-calendar-wrapper .fc .fc-timegrid-slot-label {
    border-color: transparent !important;
    background: transparent !important;
}

.crm-calendar-wrapper .fc .fc-timegrid-slot-label-cushion {
    font-size: 10px;
    font-weight: 500;
    color: var(--crm-text-muted);
    padding: 0 0.5rem !important;
}

.crm-calendar-wrapper .fc .fc-timegrid-axis {
    border-color: var(--crm-border) !important;
}

.crm-calendar-wrapper .fc .fc-timegrid-divider {
    padding: 0 !important;
    border-color: var(--crm-border) !important;
}

/* Now indicator line */
.crm-calendar-wrapper .fc .fc-timegrid-now-indicator-line {
    border-color: var(--crm-accent) !important;
    border-width: 2px !important;
}

.crm-calendar-wrapper .fc .fc-timegrid-now-indicator-arrow {
    border-color: var(--crm-accent) !important;
    color: var(--crm-accent) !important;
}

/* ── Events ─────────────────────────────────────────────────────────── */
.crm-calendar-wrapper .fc .fc-event {
    border-radius: 6px !important;
    padding: 2px 6px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    border-width: 0 !important;
    border-left-width: 3px !important;
    cursor: pointer;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: transform 0.08s, box-shadow 0.08s;
}

.crm-calendar-wrapper .fc .fc-event:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.crm-calendar-wrapper .fc .fc-event-main {
    padding: 1px 2px;
    line-height: 1.3;
}

.crm-calendar-wrapper .fc .fc-event-time {
    font-weight: 600 !important;
    font-size: 10px !important;
    opacity: 0.9;
}

.crm-calendar-wrapper .fc .fc-event-title {
    font-weight: 500 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Day-grid (month view) event styling */
.crm-calendar-wrapper .fc .fc-daygrid-event {
    margin: 1px 4px;
    padding: 2px 6px !important;
}

.crm-calendar-wrapper .fc .fc-daygrid-event-dot {
    display: none;
}

.crm-calendar-wrapper .fc .fc-daygrid-more-link {
    font-size: 10px;
    font-weight: 600;
    color: var(--crm-primary);
    padding: 0 4px;
}

/* ── List (agenda) view ─────────────────────────────────────────────── */
.crm-calendar-wrapper .fc-list {
    border-radius: 8px;
    overflow: hidden;
}

.crm-calendar-wrapper .fc .fc-list-day-cushion {
    background-color: var(--crm-bg-soft) !important;
    padding: 0.625rem 1rem !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    color: var(--crm-text-soft) !important;
}

.crm-calendar-wrapper .fc .fc-list-event {
    cursor: pointer;
}

.crm-calendar-wrapper .fc .fc-list-event:hover td {
    background-color: var(--crm-bg-soft) !important;
}

.crm-calendar-wrapper .fc .fc-list-event-dot {
    border-width: 4px !important;
}

.crm-calendar-wrapper .fc .fc-list-event-time {
    color: var(--crm-text-soft);
    font-size: 12px;
    font-weight: 500;
    padding: 0.625rem 1rem !important;
    white-space: nowrap;
}

.crm-calendar-wrapper .fc .fc-list-event-title {
    padding: 0.625rem 1rem !important;
    font-weight: 500;
    color: var(--crm-text);
}

.crm-calendar-wrapper .fc .fc-list-empty {
    background-color: var(--crm-bg);
    padding: 3rem;
    color: var(--crm-text-muted);
}

/* ── All-day & misc ─────────────────────────────────────────────────── */
.crm-calendar-wrapper .fc-popover {
    border: 1px solid var(--crm-border) !important;
    border-radius: 8px !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.crm-calendar-wrapper .fc-popover-header {
    background-color: var(--crm-bg-soft) !important;
    padding: 0.5rem 0.75rem !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    color: var(--crm-text-soft) !important;
    letter-spacing: 0.05em !important;
}

.crm-calendar-wrapper .fc-popover-body {
    padding: 0.5rem !important;
}

/* Selection mirror (when drag-selecting a time slot) */
.crm-calendar-wrapper .fc .fc-highlight {
    background-color: rgba(37, 99, 235, 0.12) !important;
    border-radius: 4px;
}

/* ── Custom event content layout ────────────────────────────────────── */
.crm-event-content {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    width: 100%;
}

.crm-event-row {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
}

.crm-event-time {
    font-size: 10px;
    font-weight: 600;
    opacity: 0.85;
    flex-shrink: 0;
}

.crm-event-title {
    font-size: 11px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
}

.crm-event-meta {
    font-size: 10px;
    opacity: 0.75;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.crm-event-priority-dot {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    flex-shrink: 0;
}

/* Status overlays — done = strikethrough effect */
.crm-event-done .crm-event-title {
    text-decoration: line-through;
    opacity: 0.7;
}

.crm-event-cancelled .crm-event-title {
    text-decoration: line-through;
    opacity: 0.55;
}

/* ── Detail modal polish ────────────────────────────────────────────── */
.crm-event-detail-card {
    background: linear-gradient(180deg, var(--crm-bg-soft) 0%, var(--crm-bg) 100%);
    border: 1px solid var(--crm-border);
    border-radius: 10px;
    padding: 0.875rem;
}

/* ── Scrollbar polish ───────────────────────────────────────────────── */
.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-track {
    background: transparent;
}

.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-thumb {
    background: #D1D5DB;
    border-radius: 4px;
}

.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-thumb:hover {
    background: #9CA3AF;
}

/* ── Responsive tweaks ──────────────────────────────────────────────── */
@media (max-width: 768px) {
    .crm-calendar-wrapper .fc .fc-toolbar.fc-header-toolbar {
        flex-direction: column;
        align-items: stretch;
    }
    .crm-calendar-wrapper .fc .fc-toolbar-chunk {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 0.25rem;
    }
    .crm-calendar-wrapper .fc .fc-toolbar-title {
        font-size: 0.95rem !important;
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Calendar.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;IACI,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;IAC1B,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI,oCAAoC;IACpC,iCAAiC;IACjC,yCAAyC;IACzC,kDAAkD;IAClD,6CAA6C;IAC7C,2CAA2C;IAC3C,8BAA8B;IAC9B,6BAA6B;IAC7B,uCAAuC;IACvC,2CAA2C;IAC3C,8CAA8C;IAC9C,uCAAuC;IACvC,4CAA4C;IAC5C,gDAAgD;;IAEhD,6GAA6G;IAC7G,eAAe;IACf,sBAAsB;AAC1B;;AAEA,0EAA0E;AAC1E;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B,qCAAqC;IACrC,2BAA2B;IAC3B,8EAA8E;IAC9E,2BAA2B;AAC/B;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,0CAA0C;AAC9C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,4CAA4C;IAC5C,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,oDAAoD;IACpD,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA,8CAA8C;AAC9C;IACI,qDAAqD;AACzD;;AAEA,0EAA0E;AAC1E;IACI,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA,uBAAuB;AACvB;IACI,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA,0EAA0E;AAC1E;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;IACf,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,iCAAiC;IACjC,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,4BAA4B;AAChC;;AAEA,0EAA0E;AAC1E;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,uDAAuD;AACvD;IACI,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA,0EAA0E;AAC1E;IACI,8EAA8E;IAC9E,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,0EAA0E;AAC1E;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0EAA0E;AAC1E;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,YAAY;IAChB;IACA;QACI,6BAA6B;QAC7B,kBAAkB;IACtB;AACJ","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────\n   SimpleCRM Calendar — professional theme overrides for FullCalendar\n   Matches CRM neutral grays + brand red accents. Polished & dense.\n   ──────────────────────────────────────────────────────────────────────── */\n\n.crm-calendar-wrapper {\n    --crm-bg: #FFFFFF;\n    --crm-bg-soft: #F9FAFB;\n    --crm-bg-hover: #F3F4F6;\n    --crm-border: #E5E7EB;\n    --crm-border-soft: #F1F2F4;\n    --crm-text: #111827;\n    --crm-text-soft: #6B7280;\n    --crm-text-muted: #9CA3AF;\n    --crm-accent: #DB0011;\n    --crm-accent-soft: #FEF2F2;\n    --crm-primary: #2563EB;\n    --crm-primary-soft: #EFF6FF;\n    --crm-success: #10B981;\n    --crm-warning: #F59E0B;\n    --crm-danger: #EF4444;\n}\n\n/* Override FullCalendar CSS variables */\n.crm-calendar-wrapper .fc {\n    --fc-border-color: var(--crm-border);\n    --fc-page-bg-color: var(--crm-bg);\n    --fc-neutral-bg-color: var(--crm-bg-soft);\n    --fc-list-event-hover-bg-color: var(--crm-bg-soft);\n    --fc-today-bg-color: rgba(59, 130, 246, 0.05);\n    --fc-now-indicator-color: var(--crm-accent);\n    --fc-event-text-color: #FFFFFF;\n    --fc-button-bg-color: #FFFFFF;\n    --fc-button-text-color: var(--crm-text);\n    --fc-button-border-color: var(--crm-border);\n    --fc-button-hover-bg-color: var(--crm-bg-soft);\n    --fc-button-hover-border-color: #D1D5DB;\n    --fc-button-active-bg-color: var(--crm-text);\n    --fc-button-active-border-color: var(--crm-text);\n\n    font-family: ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n    font-size: 13px;\n    color: var(--crm-text);\n}\n\n/* ── Header toolbar ─────────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc .fc-toolbar.fc-header-toolbar {\n    margin-bottom: 0.75rem;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.crm-calendar-wrapper .fc .fc-toolbar-title {\n    font-size: 1.05rem !important;\n    font-weight: 600;\n    color: var(--crm-text);\n    letter-spacing: -0.01em;\n}\n\n.crm-calendar-wrapper .fc .fc-button {\n    border-radius: 6px !important;\n    padding: 0.375rem 0.75rem !important;\n    font-size: 0.75rem !important;\n    font-weight: 500 !important;\n    text-transform: capitalize !important;\n    box-shadow: none !important;\n    transition: background-color 0.12s, color 0.12s, border-color 0.12s !important;\n    line-height: 1.2 !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button:focus {\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.18) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-primary:not(.fc-button-active) {\n    background-color: #FFFFFF !important;\n    color: var(--crm-text) !important;\n    border-color: var(--crm-border) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-primary:not(.fc-button-active):hover {\n    background-color: var(--crm-bg-soft) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-primary.fc-button-active {\n    background-color: var(--crm-text) !important;\n    color: #FFFFFF !important;\n    border-color: var(--crm-text) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-group > .fc-button {\n    border-radius: 0 !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-group > .fc-button:first-child {\n    border-top-left-radius: 6px !important;\n    border-bottom-left-radius: 6px !important;\n}\n\n.crm-calendar-wrapper .fc .fc-button-group > .fc-button:last-child {\n    border-top-right-radius: 6px !important;\n    border-bottom-right-radius: 6px !important;\n}\n\n.crm-calendar-wrapper .fc .fc-today-button {\n    background-color: var(--crm-primary-soft) !important;\n    color: var(--crm-primary) !important;\n    border-color: #BFDBFE !important;\n}\n\n.crm-calendar-wrapper .fc .fc-today-button:hover {\n    background-color: #DBEAFE !important;\n}\n\n.crm-calendar-wrapper .fc .fc-today-button:disabled {\n    opacity: 0.5 !important;\n}\n\n/* ── Grid & cells ───────────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc-scrollgrid {\n    border-radius: 8px;\n    overflow: hidden;\n    border-color: var(--crm-border) !important;\n}\n\n.crm-calendar-wrapper .fc-scrollgrid-section-header > * {\n    background-color: var(--crm-bg-soft);\n}\n\n.crm-calendar-wrapper .fc .fc-col-header-cell {\n    background-color: var(--crm-bg-soft);\n    padding: 0.625rem 0.25rem;\n    border-color: var(--crm-border) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-col-header-cell-cushion {\n    color: var(--crm-text-soft);\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 0 !important;\n    text-decoration: none !important;\n}\n\n.crm-calendar-wrapper .fc .fc-daygrid-day-frame,\n.crm-calendar-wrapper .fc .fc-timegrid-col-frame {\n    background-color: var(--crm-bg);\n}\n\n.crm-calendar-wrapper .fc .fc-day-other .fc-daygrid-day-top {\n    opacity: 0.35;\n}\n\n.crm-calendar-wrapper .fc .fc-daygrid-day-number {\n    padding: 0.4rem 0.5rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--crm-text-soft);\n    text-decoration: none !important;\n}\n\n.crm-calendar-wrapper .fc .fc-day-today .fc-daygrid-day-number {\n    background-color: var(--crm-accent);\n    color: #FFFFFF !important;\n    border-radius: 999px;\n    width: 22px;\n    height: 22px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0.25rem;\n    font-weight: 600;\n}\n\n/* Today column highlight (week / day views) */\n.crm-calendar-wrapper .fc .fc-day-today {\n    background-color: rgba(59, 130, 246, 0.04) !important;\n}\n\n/* ── Time slot grid ─────────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc .fc-timegrid-slot {\n    height: 2.5rem;\n    border-color: var(--crm-border-soft) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-timegrid-slot-label {\n    border-color: transparent !important;\n    background: transparent !important;\n}\n\n.crm-calendar-wrapper .fc .fc-timegrid-slot-label-cushion {\n    font-size: 10px;\n    font-weight: 500;\n    color: var(--crm-text-muted);\n    padding: 0 0.5rem !important;\n}\n\n.crm-calendar-wrapper .fc .fc-timegrid-axis {\n    border-color: var(--crm-border) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-timegrid-divider {\n    padding: 0 !important;\n    border-color: var(--crm-border) !important;\n}\n\n/* Now indicator line */\n.crm-calendar-wrapper .fc .fc-timegrid-now-indicator-line {\n    border-color: var(--crm-accent) !important;\n    border-width: 2px !important;\n}\n\n.crm-calendar-wrapper .fc .fc-timegrid-now-indicator-arrow {\n    border-color: var(--crm-accent) !important;\n    color: var(--crm-accent) !important;\n}\n\n/* ── Events ─────────────────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc .fc-event {\n    border-radius: 6px !important;\n    padding: 2px 6px !important;\n    font-size: 11px !important;\n    font-weight: 500 !important;\n    border-width: 0 !important;\n    border-left-width: 3px !important;\n    cursor: pointer;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    transition: transform 0.08s, box-shadow 0.08s;\n}\n\n.crm-calendar-wrapper .fc .fc-event:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);\n}\n\n.crm-calendar-wrapper .fc .fc-event-main {\n    padding: 1px 2px;\n    line-height: 1.3;\n}\n\n.crm-calendar-wrapper .fc .fc-event-time {\n    font-weight: 600 !important;\n    font-size: 10px !important;\n    opacity: 0.9;\n}\n\n.crm-calendar-wrapper .fc .fc-event-title {\n    font-weight: 500 !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Day-grid (month view) event styling */\n.crm-calendar-wrapper .fc .fc-daygrid-event {\n    margin: 1px 4px;\n    padding: 2px 6px !important;\n}\n\n.crm-calendar-wrapper .fc .fc-daygrid-event-dot {\n    display: none;\n}\n\n.crm-calendar-wrapper .fc .fc-daygrid-more-link {\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--crm-primary);\n    padding: 0 4px;\n}\n\n/* ── List (agenda) view ─────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc-list {\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.crm-calendar-wrapper .fc .fc-list-day-cushion {\n    background-color: var(--crm-bg-soft) !important;\n    padding: 0.625rem 1rem !important;\n    font-size: 11px !important;\n    font-weight: 600 !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    color: var(--crm-text-soft) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-list-event {\n    cursor: pointer;\n}\n\n.crm-calendar-wrapper .fc .fc-list-event:hover td {\n    background-color: var(--crm-bg-soft) !important;\n}\n\n.crm-calendar-wrapper .fc .fc-list-event-dot {\n    border-width: 4px !important;\n}\n\n.crm-calendar-wrapper .fc .fc-list-event-time {\n    color: var(--crm-text-soft);\n    font-size: 12px;\n    font-weight: 500;\n    padding: 0.625rem 1rem !important;\n    white-space: nowrap;\n}\n\n.crm-calendar-wrapper .fc .fc-list-event-title {\n    padding: 0.625rem 1rem !important;\n    font-weight: 500;\n    color: var(--crm-text);\n}\n\n.crm-calendar-wrapper .fc .fc-list-empty {\n    background-color: var(--crm-bg);\n    padding: 3rem;\n    color: var(--crm-text-muted);\n}\n\n/* ── All-day & misc ─────────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc-popover {\n    border: 1px solid var(--crm-border) !important;\n    border-radius: 8px !important;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;\n}\n\n.crm-calendar-wrapper .fc-popover-header {\n    background-color: var(--crm-bg-soft) !important;\n    padding: 0.5rem 0.75rem !important;\n    font-size: 11px !important;\n    font-weight: 600 !important;\n    text-transform: uppercase !important;\n    color: var(--crm-text-soft) !important;\n    letter-spacing: 0.05em !important;\n}\n\n.crm-calendar-wrapper .fc-popover-body {\n    padding: 0.5rem !important;\n}\n\n/* Selection mirror (when drag-selecting a time slot) */\n.crm-calendar-wrapper .fc .fc-highlight {\n    background-color: rgba(37, 99, 235, 0.12) !important;\n    border-radius: 4px;\n}\n\n/* ── Custom event content layout ────────────────────────────────────── */\n.crm-event-content {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n    width: 100%;\n}\n\n.crm-event-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n}\n\n.crm-event-time {\n    font-size: 10px;\n    font-weight: 600;\n    opacity: 0.85;\n    flex-shrink: 0;\n}\n\n.crm-event-title {\n    font-size: 11px;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n}\n\n.crm-event-meta {\n    font-size: 10px;\n    opacity: 0.75;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.crm-event-priority-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 999px;\n    flex-shrink: 0;\n}\n\n/* Status overlays — done = strikethrough effect */\n.crm-event-done .crm-event-title {\n    text-decoration: line-through;\n    opacity: 0.7;\n}\n\n.crm-event-cancelled .crm-event-title {\n    text-decoration: line-through;\n    opacity: 0.55;\n}\n\n/* ── Detail modal polish ────────────────────────────────────────────── */\n.crm-event-detail-card {\n    background: linear-gradient(180deg, var(--crm-bg-soft) 0%, var(--crm-bg) 100%);\n    border: 1px solid var(--crm-border);\n    border-radius: 10px;\n    padding: 0.875rem;\n}\n\n/* ── Scrollbar polish ───────────────────────────────────────────────── */\n.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-thumb {\n    background: #D1D5DB;\n    border-radius: 4px;\n}\n\n.crm-calendar-wrapper .fc-scroller::-webkit-scrollbar-thumb:hover {\n    background: #9CA3AF;\n}\n\n/* ── Responsive tweaks ──────────────────────────────────────────────── */\n@media (max-width: 768px) {\n    .crm-calendar-wrapper .fc .fc-toolbar.fc-header-toolbar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    .crm-calendar-wrapper .fc .fc-toolbar-chunk {\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 0.25rem;\n    }\n    .crm-calendar-wrapper .fc .fc-toolbar-title {\n        font-size: 0.95rem !important;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
